import React from 'react';
import './Hero.css';

function Hero() {
  const heroBgStyle = {
    backgroundImage: `url(${process.env.PUBLIC_URL}/assets/NeXusNeuroHero.webp)`,
  };

  return (
    <section className="nn-hero">
      <div className="nn-hero-bg" style={heroBgStyle} />
      <div className="nn-hero-frame reveal">
        <img
          src="/assets/nexus_neuro_logo.webp"
          alt="NeXus NeuroInformatics, Inc."
          className="nn-hero-wordmark"
        />
        <span className="nn-hero-label">Biomedical Technologies · Digital Health</span>
        <h1 className="nn-hero-title">
          When Clinical<br />
          AI Demands<br />
          <span className="iso-gold">ISO 17511:2020</span><br />
          <span className="iso-gold">Traceability.</span>
        </h1>
        <p className="nn-hero-deck">
          Biology-native AI, built on <strong>AetherProtocols</strong>.
        </p>
        <div className="nn-hero-pills">
          <span className="nn-pill">Delaware C-Corporation</span>
          <span className="nn-pill"><strong>4</strong>&nbsp;U.S. provisional patents</span>
          <span className="nn-pill-break" aria-hidden="true"></span>
          <span className="nn-pill">FDA CDER COA LOI · CDRH De Novo Pre-Sub</span>
          <span className="nn-pill-break" aria-hidden="true"></span>
          <span className="nn-pill">NSF SBIR <strong>#00120933</strong> · submitted 2026-07-26</span>
        </div>
      </div>
    </section>
  );
}

export default Hero;
